import Config from "@via/utils/config.tsx";
import { isLocalhost } from "@via/utils/helpers.tsx";
import { useConfigurations } from "@via/api/configuration.tsx";

/**
 * Resolves the URL to give an AI assistant when adding Foundry Connect as a
 * custom MCP connector. The same URL serves every client.
 *
 * Mirrors the MCP URL resolution used in
 * personal-access-tokens/components/token-display-modal.tsx so both surfaces
 * always agree on the connector URL.
 */
export const useMcpConnectorUrl = (): string => {
  // Use Config.HOST which includes the base path (e.g., /beta/) from runtime config
  const currentHostname = Config.HOST || window.location.origin;
  const isLocalhostEnv = isLocalhost(currentHostname);

  // Get MCP URL from backend configuration
  const { data: configurations } = useConfigurations();
  // For localhost: use currentHostname/mcp
  // For production: use MCP_URL from config (separate subdomain)
  return isLocalhostEnv
    ? `${currentHostname}/mcp`
    : configurations?.MCP_URL || `${currentHostname}/mcp`;
};
